import { RequiredByRefCount } from '../ref-counter';

export const SERVICE_DEFINITIONS_FETCH = 'SERVICE_DEFINITIONS_FETCH',
  SERVICE_SELECTED_ADD = 'SERVICE_SELECTED_ADD',
  SERVICE_SELECTED_ADD_QUANTITY = 'SERVICE_SELECTED_ADD_QUANTITY',
  SERVICE_CHANGE_QUANTITY = 'SERVICE_CHANGE_QUANTITY',
  SERVICE_SELECTED_ITEM_DELETE = 'SERVICE_SELECTED_ITEM_DELETE',
  SERVICE_SELECTED_JOB_ITEMS_ADD = 'SERVICE_SELECTED_JOB_ITEMS_ADD',
  SERVICE_SELECTED_REFRESH = 'SERVICE_SELECTED_REFRESH',
  SERVICE_SELECTED_SPECIFY = 'SERVICE_SELECTED_SPECIFY',
  SERVICE_PRESELECT_AUTOMATION = 'SERVICE_PRESELECT_AUTOMATION',
  SERVICE_PRESELECT_AUTOMATION_BY_PRODUCT =
    'SERVICE_PRESELECT_AUTOMATION_BY_PRODUCT',
  SERVICE_SELECTED_ITEM_UNREF = 'SERVICE_SELECTED_ITEM_UNREF',
  CUSTOM_SERVICE_PUSH_ERROR = 'CUSTOM_SERVICE_PUSH_ERROR',
  CUSTOM_SERVICE_RESET_ERRORS = 'CUSTOM_SERVICE_RESET_ERRORS';

export interface StoreServicesGetterParams {
  jobId: string;
  serviceSfid?: string;
  productId?: string;
  service?: string;
}

export interface StoreServicesGetterPriceNetParams
  extends StoreServicesGetterParams {
  targetField: string;
  invoicingTarget: string[];
  job_view_services: any[];
}

export interface ServiceEntry {
  jobId: string;
  quantity: number;
  service: string | null;
  value_entry?: string | number | null;
  productId: string | null;
  requiredBy?: RequiredByRefCount;
}

export interface ServicesState {
  definitions: any;
  selected: {
    [jobId: string]: ServiceEntry[];
  };
  customServicesErrors: {
    [newCustomServiceIndex: number]: string;
  };
}
